<template>
    <a-modal 
        v-model="visible" 
        :title="$t('dashboard-page.payments')" 
        :closable="false" 
        :ok-text="$t('modal-btn.alter-confirm-btn-caption')" 
        :cancel-text="$t('modal-btn.alter-cancel-btn-caption')" 
        @ok="handleOk" 
        @cancel="handleCancel"
    >
        <h4>{{$t('confirm-payment.title')}}</h4>
    </a-modal>
</template>

<script>
import { paymentsClient } from "../../../../api/config.js";
import { toastMixin } from "../../../../mixins/ToastMixin.js";
export default {
    name: "CompanyConfirmPaymentModal",
    mixins: [ toastMixin ],
    data(){
        return{
            reason: "",
            visible: false,
            applicantId: "",
        }
    },
    methods:{
        showModal(id) {
            this.visible = true;
            this.applicantId = id;
        },
        handleCancel(){
            this.visible = false;
        },
        handleOk(){
            // let data = {
            //     "id": this.applicantId,
            //     "reason": this.reason
            // }
            let id = this.applicantId;
            paymentsClient.companyConfirmPayments(id).then(res => {
                if (!res.networkError){
                    if (res.status == 202){
                        this.successToast(this.$t('toast-success-messages.success'));
                        this.visible = false;
                    }else{
                        this.errorToast(this.$t('toast-error-messages.error') + res.status);
                    }
                }else{
                    this.errorToast(this.$t('toast-error-messages.network-error'));
                }
            })
        }
    }
}
</script>

<style>

</style>